import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { GET_POSTS } from "../../constant/Apipath";
import { Getrequestcall } from "../../request/Getrequest";
import Loader from "../../common/Loader";
import { Avatar, Box, Button, Card, List, Stack, TextField } from "@mui/material";
import ChatIcon from "@mui/icons-material/Chat";
import { BIGrey } from "../../assets/helpers";
import { useDispatch } from "react-redux";
import { setShowReport, showAddPostModal } from "../../redux/actions/actions";
import { AddPostDialog } from "../common/AddPostDialog";
import InfiniteScroll from "react-infinite-scroll-component";
import Emptydata from "../common/Emptydata";
import { English } from "../../constant/EnglishFallback";
import Post from "../new-community/Post";
import Pages from "../../constant/ReportModel";

const ProductPostsSection = ({ id, scrollId }) => {
  const { loginData, showAddpost, multiLanguageData, selectedLanguage, reportSuccess, reportData } = useSelector(
    (state) => state?.main
  );
  const currentUserId = loginData?.userInformation?.UserId ?? 0;
  const LanguageData = multiLanguageData?.Products || {};
  const {
    TEXT_WHAT_DO_TALK_ABOUT = English.Products.TEXT_WHAT_DO_TALK_ABOUT,
    TEXT_POST_MESSAGE_TITLE = English.Products.TEXT_POST_MESSAGE_TITLE,
    TEXT_NO_INFO_REVIEW = English.Products.TEXT_NO_INFO_REVIEW,
    NO_RESULT = English.Products.NO_RESULT
  } = LanguageData || {};

  const {
    BUTTON_ADD_POST = English.BUTTON_ADD_POST
  } = multiLanguageData?.Home || {};
  
  const [postsData, setPostsData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const [pageNumber, setPageNumber] = useState(1);
  const [allDataLoaded, setAllDataLoaded] = useState(false);
  const [hasData, setHasData] = useState(false);

  useEffect(() => {
    getInitialData();
  }, []);

  useEffect(() => {
    if (reportSuccess !== true && reportData?.AppScreenId === Pages?.post?.id) {
      getInitialData();
      let reportObj = {
        showReport: false,
        recordId: 0,
        name: "",
        AppScreenId: 0
      };
      dispatch(setShowReport(reportObj));
    }
  }, [reportSuccess])

  const getInitialData = async () => {
    setIsLoading(true);
    await getPostsData(1, true);
    setIsLoading(false);
  };

  const getPostsData = async (pageNr, fristTimeApiCall = true) => {
    try {
      setAllDataLoaded(true);
      let res = await Getrequestcall(
        `${GET_POSTS}/${currentUserId}/4/${id}/${pageNr ?? 1}/25/${selectedLanguage}`,
        loginData?.accessToken
      );
      let resData = res?.data?.data ?? [];
      if (pageNr > 1) {
        setTimeout(() => {
          setPostsData((prevProducts) => [...prevProducts, ...resData]);
        }, 500);
      } else {
        setPageNumber(1);
        setPostsData(resData);
        if (fristTimeApiCall) {
          setHasData(resData?.length > 0);
        }
      }
    } catch (error) {
      console.log("getPostsData-> Error While Getting Post Data: ", error);
    } finally {
      setAllDataLoaded(false);
      setIsLoading(false);
    }
  };

  const onWritePostClick = (event) => {
    event.target.blur();
    dispatch(showAddPostModal(true));
  };

  const handleCloseAddPostModal = () => {
    dispatch(showAddPostModal(false));
  };

  const increaseOffset = (callback) => {
    setPageNumber((prevPageNr) => prevPageNr + 1);
    callback(pageNumber + 1);
  };


  const handleAddPostClick = () => {
    dispatch(showAddPostModal(true));
  };


  const NoInformation = () => {
    return (
      <Stack sx={{ height: "100%" }}>
        <Button variant="text" sx={{ alignSelf: "flex-end" }} onClick={handleAddPostClick}>
          {BUTTON_ADD_POST}
        </Button>
        <Box className="empty-data-card">
          <Emptydata
            icon={<ChatIcon className="emptydata-icon" />}
            firstText={TEXT_NO_INFO_REVIEW}
          />
        </Box>
      </Stack>
    );
  };

  const WritePostCard = () => {
    return (
      <Card className="pagelist-content" sx={{ p: 1.5, backgroundColor: "#f2f2f2" }}>
        <Stack direction={"row"} alignItems={"center"} spacing={1.5}>
          <Avatar alt="Profile Picture" src={loginData?.pictureUrl} />
          <TextField
            variant="outlined"
            fullWidth
            onClick={onWritePostClick}
            placeholder={TEXT_WHAT_DO_TALK_ABOUT}
          />
        </Stack>
      </Card>
    );
  };

  const renderPosts = () => {
    return (
      <>
        <Stack gap={1.5}>
          {postsData?.length > 0 ? (
            <InfiniteScroll
              dataLength={postsData?.length}
              next={async () => {
                increaseOffset((pageNumber) => {
                  getPostsData(pageNumber);
                });
              }}
              hasMore={true}
              loader={
                !allDataLoaded ? null : (
                  <h4 style={{ display: "flex", justifyContent: "center" }}>
                    <Loader />
                  </h4>
                )
              }
              scrollableTarget={scrollId}>
              <List disablePadding>
                <Stack gap={1}>
                  {postsData?.map((data) => (
                    <Post
                      postItem={data}
                      posts={postsData}
                      setPosts={setPostsData}
                      from="productDetail"
                    />
                  ))}
                </Stack>
              </List>
            </InfiniteScroll>
          ) : (
            <>
              <Stack
                direction={"row"}
                justifyContent={"center"}
                alignItems={"center"}
                style={{ color: BIGrey, padding: "30px" }}>
                {NO_RESULT}
              </Stack>
            </>
          )}
        </Stack>
      </>
    );
  };

  return (
    <Box className="main-content-card-list">
      <Card className="pagelist-content" sx={{ p: 2 }}>
        {isLoading ? (
          <Loader />
        ) : (
          <Stack gap={1.5}>
            <WritePostCard />
            {hasData ? renderPosts() : <NoInformation />}
          </Stack>
        )}
      </Card>
      {showAddpost && (
        <AddPostDialog
          appRecordId={id}
          appId={4}
          open={showAddpost}
          messageTitle={TEXT_POST_MESSAGE_TITLE}
          onClose={handleCloseAddPostModal}
          updatePosts={() => getPostsData(1)}
        />
      )}
    </Box>
  );
};

export default ProductPostsSection;
